import { render, staticRenderFns } from "./InfoSideBar.vue?vue&type=template&id=70936cba&lang=true&"
import script from "./InfoSideBar.vue?vue&type=script&lang=js&"
export * from "./InfoSideBar.vue?vue&type=script&lang=js&"
import style0 from "./InfoSideBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports